<template>
    <div>
        <template v-if="!isDetail">
        <pt-sub-title title="订单信息"></pt-sub-title>
        <table :class="$style['order-message-table']">
              <tr>
                <td>订单号：</td>
                <td>{{orderDetail.orderNumber}}</td>
            </tr>
             <tr>
                <td>商品名称：</td>
                <td>{{orderDetail.goods&&orderDetail.goods[0]&&orderDetail.goods[0].name}}</td>
            </tr>
            <tr v-if="orderDetail.shippingAddress">
                <td>收货信息：</td>
                <td>
                    <span>{{orderDetail.shippingAddress.contactName}}</span>
                    <span>{{orderDetail.shippingAddress.phone}}</span>
                    <span>{{orderDetail.shippingAddress.provinceName+orderDetail.shippingAddress.cityName+orderDetail.shippingAddress.districtName+orderDetail.shippingAddress.postAddress}}</span>
                </td>
            </tr>
             <tr>
                <td>备注：</td>
                <td>
                    {{orderDetail.remark?orderDetail.remark:'--'}}
                </td>
            </tr>
        </table>
        </template>
        <pt-sub-title title="发货信息"></pt-sub-title>
        <div :class="$style['sampling-message']">
        <!-- <table  v-for="(item,index) in form.samples"  :key="index">
            <pt-form-list-item label="采样盒ID：" :required="true">
                <wt-input v-model="item.sampleId" data-vv-as="采样盒ID"  name="sampleId" v-validate="'required'"></wt-input>
            </pt-form-list-item>
            <pt-form-list-item label="样本类型：" :required="true">
                <wt-selector :options="sampleTypes" v-model="item.sampleType" :class="$style['sample-type-select']"  data-vv-as="样本类型"  name="sampleType" v-validate="'required'"></wt-selector>
            </pt-form-list-item>
        </table> -->
        <template v-if="needSample && !isIntegral">
            <div v-for="(item,index) in samples"  :key="index" >
                <div :class="$style['sample-item']">
                    <div :class="$style['sample-item-filed']"><div :class="$style['sample-item-filed-label']"><span style="color:red">*</span>采样盒ID：</div>
                    <wt-input v-model="item.sampleId" data-vv-as="采样盒ID"  name="sampleId" v-validate="'required'" :class="$style['sample-item-filed-input']"></wt-input></div>
                    <div :class="$style['sample-item-filed']"><div :class="$style['sample-item-filed-label']"><span style="color:red">*</span>样本类型：</div>
                    <wt-selector :options="sampleTypes" v-model="item.sampleType" :class="$style['sample-type-select']"  data-vv-as="样本类型"  name="sampleType" v-validate="'required'"></wt-selector></div>
                    <div :class="$style['sample-delete']">
                    <el-button v-if="index>0" type="text" @click="deleteSample(index,item)">删除</el-button>
                    </div>
                </div>
            </div>
            <div>
                <el-button type="text" @click="addSample">添加一个采样盒</el-button>
            </div>
        </template>
        <table :class="$style['sampling-courier-message']">
            <pt-form-list-item label="快递公司：" :required="!isONLINE">
            <wt-selector v-model="courier_id" data-vv-as="快递公司" :class="$style['sample-type-select']" :options="expressesList"  name="courierName"
            v-validate="isONLINE?'':'required'" :props="expressesProp" :allow-create="true" :filterable="true" :clearable="true" placeholder="请输入或选择"></wt-selector>
            </pt-form-list-item>
            <pt-form-list-item label="快递单号：" :required="!isONLINE">
                <wt-input v-model="form.courierNumber"  data-vv-as="快递单号"  name="courierNumber"  v-validate="isONLINE?'':'required'"></wt-input>
            </pt-form-list-item>
            <pt-form-list-item label="备注：" v-if="needRemarks">
                <wt-input v-model="form.remark" type="textarea" rows='4' :autosize="{ minRows: 4, maxRows: 5}" ></wt-input>
            </pt-form-list-item>
        </table>
        <div :class="$style['sampling-message-button']">
            <el-button type="primary" size="small" @click="deliver" :loading="loading">发货完成</el-button>
            <el-button  type="primary" plain size="small" @click="cancel">取消</el-button>
        </div>
        </div>
    </div>
</template>
<script>
import emitter from '@/mixins/emitter'
import formMixins from 'mixins/form'
import { getDeleteSpace } from 'utils/formUtils'
import { sampleTypes } from '../goods-order-options'
export default {
  mixins: [emitter, formMixins],
  data () {
    return {
      form: this.formVlue,
      loading: false,
      sampleTypes: sampleTypes,
      expressesList: [],
      expressesProp: {
        label: 'name',
        value: 'id'
      },
      courier_id: '',
      samples: []
    }
  },
  props: {
    isDetail: {
      type: Boolean,
      default: false
    },
    isList: {
      type: Boolean,
      default: false
    },
    isIntegral: {
      type: Boolean,
      default: false
    },
    orderId: {
      type: String,
      default: ''
    },
    formVlue: {
      type: Object,
      default: function () {
        return {}
      }
    },
    orderDetail: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  computed: {
    // 商品
    goods () {
      return this.orderDetail.goods && this.orderDetail.goods[0]
    },
    // 是否是虚拟发货
    isONLINE () {
      return this.goods.shippingMode === 'ONLINE'
    },
    // 订单是否是重采订单
    isResamaple () {
      return this.orderDetail.placementDetails.resampleOrder
    },
    // 是否需要备注
    needRemarks () {
      return this.isONLINE || !this.isPlatformGene
    },
    // 是否是自营基因商品的订单
    isPlatformGene () {
      return this.goods.type === 'GENE' && this.goods.goodsBelong === 'PLATFORM'
    },
    // 是否需要填写样本
    needSample () {
      return !this.isONLINE && this.isPlatformGene
    }
  },
  watch: {
    formVlue: {
      handler: function (val) {
        this.form = val
      },
      deep: true
    },
    orderDetail: {
      handler: function (val) {
        this.samples = []
        // 样本数量
        let sampleNumber = !this.needSample ? 0 : (this.isResamaple ? 1 : val.placementDetails.goods.number)
        for (let i = 0; i < sampleNumber; i++) {
          this.samples.push({
            sampleId: null
          })
        }
      },
      immediate: true
    },
    courier_id: {
      handler: function (val) {
        let isAdd
        if (this.expressesList.length > 0) {
          isAdd = true
          this.expressesList.forEach(item => {
            if (item.id === val) {
              this.form.courierId = val
              this.form.courierName = item.name
              isAdd = false
            }
          })
        }
        if (isAdd && val) {
          this.createExporess(val)
        }
      }
    }
  },
  methods: {
    deleteSample (index, item) {
      this.samples.splice(index)
    },
    // 添加采样盒
    addSample () {
      this.samples.push({
        sampleId: null
      })
    },
    createExporess (val) {
      val = val.replace(/(^\s*)|(\s*$)/g, '')
      val = val && getDeleteSpace(val)
      this.$store.dispatch('createExporess', { name: val }).then(res => {
        this.$message.success('新建快递公司成功')
        this.form.courierId = res.id
        this.form.courierName = res.name
      }).catch(err => {
        this.$message.error(err || '新建快递公司失败')
      })
    },
    getExpresses () {
      let data = {
        page: 0,
        size: 9999
      }
      this.$store.dispatch('getExpresses', data).then(res => {
        this.expressesList = res
      }).catch(err => {
        this.$message.error(err || '获取快递公司数据失败')
      })
    },
    deliver () {
      this.validate('form').then(formValue => {
        if (!this.needSample && this.isResamaple && this.samples.length !== this.orderDetail.placementDetails.goods.number) {

        }
        if (!this.isIntegral) {
          formValue.samples = this.samples
        }
        if (formValue.samples && formValue.samples.length) {
          formValue.samples.forEach(item => {
            item.sampleId = item.sampleId && getDeleteSpace(item.sampleId, true)
          })
        }
        formValue.courierNumber = formValue.courierNumber && getDeleteSpace(formValue.courierNumber, true)
        this.creatDeliverGoodsDetail(formValue)
      })
    },
    cancel () {
      this.form = {}
      this.$emit('close')
    },
    creatDeliverGoodsDetail (val) {
      let data = {
        mallOrderId: this.orderId,
        expressDetails: val
      }
      if (this.isIntegral) {
        data = {
          pointsOrderId: this.orderId,
          expressDetails: val
        }
      }
      let ajaxUrl = this.isIntegral ? 'getIntegralGoodsDelivery' : 'creatDeliverGoodsDetail'
      this.loading = true
      this.$store.dispatch(ajaxUrl, data).then(res => {
        this.loading = false
        this.$message.success('订单发货成功')
        if (this.isList) {
          this.$emit('getOrderList')
        } else {
          this.dispatch('pt-order-detail', 'goodsOrderDetail')
        }
        this.cancel()
      }).catch(err => {
        this.loading = false
        this.$message.error(err || '订单发货失败')
      })
    }
  },
  created () {
    this.getExpresses()
  }
}
</script>
<style module lang="less">
@import "~less/var";
.sample-item{
color:#222;
font-size: 15px;
display: flex;
padding: 0 2PX;
margin-top:10px;
}
.sample-item-filed{
    display: flex;
    width: 300PX;
    margin-right: 10PX
}
.sample-item-filed-label{
    white-space: nowrap;
    margin-right: 10px;
    line-height: 40px;
    span{
        margin-right: 3PX
    }
}
.sample-item-filed-input{
    flex: 1
}
.sampling-courier-message{
    width: 300PX;
    border: none;
    border-spacing:0;
    :global
    tr{
        border: none;
        border-spacing:0;
        td{
            border: none;
            border-spacing:0;
        }
    }
}
.order-message-table{
    padding: 0 20px;
    :global
    tr{
        td{
            line-height: 30px;
            font-size: 14px;
        &:first-child{
            display: flex;
            color:@mainColor;
            justify-content: flex-end;
            white-space:nowrap
        }
            span{
                display: inline-block
            }
        }
    }
}
.sample-type-select{
    width: 100%
}
.sampling-message{
    //  max-width: 350px;
     padding:0 20px;
     .sampling-message-button{
         margin-top: 10px;
     }
    :global
    tr{
        max-width: 280px;
    }
}
.sample-delete{
    min-width: 30PX;
}
</style>
